export default {
  mounted: function(){
    const section = this.$route.query['section'];
    if(section !== undefined){
      const sectionRect = document.getElementById(section).getBoundingClientRect();
      window.scrollBy({
        top: sectionRect.top - 150,
        left: 0,
        behavior: 'auto'
      })
    }
  }
}